import React from "react";
import logo from "../../assets/img/logo.jpeg";
import { UserWelcomeStyled, BadgeStyled } from "./userWelcome.styles";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectUserInfo } from "../../redux/user/user.selectors";
import useMediaQuery from "../../hooks/useMediaQuery";
const UserWelcome = ({ selectUserInfo }) => {
  const { firstname, lastname, status_persian } = selectUserInfo;
  let size = useMediaQuery();
  return (
    <UserWelcomeStyled className="d-flex align-items-center">
      <div className="img">
        <img src={logo} width="100%" alt="logo" />
      </div>
      <div>
        <div className="font-weight-bold">
          {firstname && lastname ? `${firstname} ${lastname}` : `کاربر عزیز`}
        </div>
        {["xm"].includes(size) ? (
          <BadgeStyled>{status_persian ? status_persian : "..."}</BadgeStyled>
        ) : (
          <div>به بارنت خوش‌آمدی.</div>
        )}
      </div>
    </UserWelcomeStyled>
  );
};
const mapStateToProps = createStructuredSelector({
  selectUserInfo: selectUserInfo,
});
export default connect(mapStateToProps)(UserWelcome);
